import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { ROLE_LABEL } from "../lib/format";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const load = () => api.get("/admin/users").then(r => setUsers(r.data));
  useEffect(() => { load(); }, []);
  const updateRole = async (uid, role) => { await api.patch(`/admin/users/${uid}`, { role }); load(); };
  return (
    <div className="space-y-6">
      <div>
        <div className="text-[11px] tracking-[0.2em] uppercase text-gold font-bold mb-2">Admin</div>
        <h1 className="font-display text-4xl font-bold tracking-tighter text-navy">Users</h1>
      </div>
      <div className="card-base overflow-x-auto">
        <table className="table-base">
          <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Company</th><th>Created</th></tr></thead>
          <tbody>
            {users.map(u => (
              <tr key={u.user_id} data-testid={`admin-user-${u.user_id}`}>
                <td className="flex items-center gap-2"><img src={u.picture} className="w-7 h-7 rounded-full" alt="" /><span className="font-semibold">{u.name}</span></td>
                <td className="text-sm">{u.email}</td>
                <td>
                  <select className="input-base" value={u.role} onChange={e => updateRole(u.user_id, e.target.value)} data-testid={`role-select-${u.user_id}`}>
                    {Object.entries(ROLE_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </td>
                <td className="font-mono text-xs">{u.company_id || "—"}</td>
                <td className="text-xs text-slate-500">{u.created_at?.slice(0,10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
